export class AccessPoint
{
    constructor(
        public ssid: string,
        public intensity: number,
        public security: string)
        {
        }
}
